/// <amd-module name="ExtensionManagement/ManagementHub/ExtensionHistoryTable" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";

import { PersonaDetailsProvider } from "VSS/Features/Identities/PersonaDetailsProvider";

import { IVssPageContext } from "VSS/Platform/Context";

import { Ago } from "VSSUI/Ago";
import { ISimpleListCell } from "VSSUI/List";
import { IPersonaProvider, Persona, PersonaSize } from "VSSUI/Persona";
import { Table, ITableColumn, SimpleTableCell, renderSimpleCell, renderSimpleCellValue } from "VSSUI/Table";
import { AgoFormat } from "VSSUI/Utilities/Date";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";

import { IHistoryAction } from "./UIContracts";

import * as Resources from "ExtensionManagement/ManagementHub/Resources.ExtManagmentHub";

interface IExtensionHistoryTableProps {
    /**
     * Observable History of an extension
     */
    history: (IHistoryAction | ObservableValue<IHistoryAction | undefined>)[];

    /**
     * Context for Persona provider.
     */
    pageContext: IVssPageContext;
}

/**
 * Table that shows extension audit log
 */
export class ExtensionHistoryTable extends React.Component<IExtensionHistoryTableProps> {
    private columns: ITableColumn<IHistoryAction | ISimpleListCell>[];
    private personaProvider: IPersonaProvider;

    constructor(props: IExtensionHistoryTableProps) {
        super(props);

        this.columns = [
            { id: "user", name: Resources.User, width: 300, renderCell: this.renderUserNameColumn },
            { id: "date", name: Resources.Date, width: 200, renderCell: this.renderActionTimeColumn },
            { id: "auditAction", name: Resources.Action, width: -100, minWidth: 200, renderCell: renderSimpleCell }
        ];

        this.personaProvider = new PersonaDetailsProvider(this.props.pageContext);
    }

    public render(): JSX.Element {
        return (
            <Table<IHistoryAction>
                columns={this.columns}
                itemProvider={new ArrayItemProvider<IHistoryAction | ObservableValue<IHistoryAction | undefined>>(this.props.history)}
                singleClickActivation={false}
                ariaLabel = {Resources.History}
            />
        );
    }

    private renderActionTimeColumn = (
        rowIndex: number,
        columnIndex: number,
        tableColumn: ITableColumn<IHistoryAction>,
        tableItem: IHistoryAction
    ): JSX.Element => {
        let content: JSX.Element | undefined = undefined;
        const date = tableItem.date;

        if (date) {
            content = <Ago date={date} format={AgoFormat.Compact} />;
        }
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                {content}
            </SimpleTableCell>
        );
    };

    private renderUserNameColumn = (
        rowIndex: number,
        columnIndex: number,
        tableColumn: ITableColumn<ISimpleListCell>,
        tableItem: IHistoryAction
    ): JSX.Element => {
        let simpleListCell: ISimpleListCell = {
            iconProps: tableItem.userIconUrl
                ? {
                      render: (className: string) => {
                          const identity = {
                              displayName: tableItem.userName,
                              id: tableItem.userId,
                              imageUrl: tableItem.userIconUrl
                          };
                          return (
                              <Persona className={className} identity={identity} size={PersonaSize.size24} personaProvider={this.personaProvider} />
                          );
                      }
                  }
                : {
                      className: "vstsLogo",
                      iconName: "VSTSLogo"
                  },
            text: tableItem.userName,
            textClassName: "text-ellipsis"
        };

        return renderSimpleCellValue(columnIndex, tableColumn, simpleListCell);
    };
}
